import { h } from "vue";
import { useModal } from "vue-final-modal";

import Modal, { type ModalFormat } from "@/components/modals/Modal.vue";
import PluginModal from "@/components/modals/PluginModal.vue";
import { RouteNames } from "@/routes/types";
import type { Router } from "@/types";

export type PluginModalOptions = {
  pluginId: string;
  featureName: string;
};

export const openPluginModal = (
  router: Router,
  options: PluginModalOptions
) => {
  const { open } = useModal({
    component: Modal,
    attrs: {
      title: "Plugin Required",
      format: "full" satisfies ModalFormat,
      isCancellable: true,
      showTitleBar: false,
      modalButtons: [
        {
          title: "Configure",
          kind: "main",
          type: "primary",
          func: async () => {
            await router.push({ name: RouteNames.SettingsPlugins });
          },
        },
      ],
    },
    slots: {
      default: () =>
        h(PluginModal, {
          pluginId: options.pluginId,
          featureName: options.featureName,
        }),
    },
  });

  open();
};
